import React, {Component} from "react";
import withRouter from './withRouter';

import Image from 'react-bootstrap/Image';

class NotConnect extends Component {

    render() {

        return (
            <div className="prevent-select d-flex align-items-center justify-content-center vh-100">
                <div className="text-center">
                    <Image src="/images/icons/attention-triangle.svg" className="mb-4" width={50} />
                    <h5 className="text-bold">Сервер недоступен</h5>
                    <p className="">Проверьте соединения с интернетом или попробуйте позже</p>
                </div>
            </div>
        )

    }
}

export default withRouter(NotConnect);